import { useSelector } from "react-redux";
import Button from "./Buttons";
import Column from "./Column";
import PropTypes from "prop-types";
import React from "react";
import Row from "./Row";
import Section from "./Section";
import { TextHeader } from "./Texts";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import mainSelectors from "modules/main/selectors";
import styled from "styled-components";

const TopBar = ({ title, subTitle }) => {
  console.log("in TopBar", title);
  //eslint-disable-next-line no-unused-vars
  const [t, i18n] = useTranslation();
  let history = useHistory();

  const currentDashboard = useSelector((state) => mainSelectors.currentDashboardResult(state));
  const authAdproResult = useSelector((state) => mainSelectors.authAdproResult(state));

  const goContact = () => {
    history.push("/contact");
  };
  return (
    <Section margin="0 0 0px" padding="0 0 0 0" bgColor="transparent" boxShadow="none">
      <Row className="top-bar" alignItems="center">
        <Column>
          {subTitle && <SubTitleStyle>{subTitle}</SubTitleStyle>}
          <TextHeader>{title}</TextHeader>
        </Column>
        <Column wrap>
          {authAdproResult.result === 0 &&
            currentDashboard.data.dashboard === "google" &&
            authAdproResult.data.adwords_managed_service === "Y" && (
              <Button type="secondary" onClick={goContact} round>
                {t("__contact_specialist")}
              </Button>
            )}
        </Column>
      </Row>
    </Section>
  );
};

TopBar.propTypes = {
  title: PropTypes.string,
};

export default TopBar;

const SubTitleStyle = styled.div`
  font-weight: 700;
  color: #afafaf;
  font-size: 12px;
`;
